import { slideDown } from './utilities.js';
import { slideUp } from './utilities.js';

window.addEventListener("load", () => {

    const subMenu = document.querySelector('.remaining-submenu');
    const arrows = document.querySelectorAll('.ki-submenu-container .arrow');

    if (!subMenu || !arrows.length) return;

    const mq = window.matchMedia("(max-width: 781px)");

    function onArrowClick(e) {

        if (subMenu.classList.contains('open')) {
            slideUp(subMenu, 300);
        } else {
            slideDown(subMenu, 300);
        }

        subMenu.classList.toggle('open');
        e.currentTarget.classList.toggle('open');
    }

    function bindEvents() {
        arrows.forEach((arrow) => {
            arrow.addEventListener('click', onArrowClick);
        });
    }

    function unbindEvents() {
        arrows.forEach((arrow) => {
            arrow.removeEventListener('click', onArrowClick);
            arrow.classList.remove('open');
        });
    }

    function resetState(isMobile) {

        if (isMobile) {
            subMenu.style.display = "none";
            subMenu.classList.remove('open');
        } else {
            subMenu.style.display = "flex";
            subMenu.classList.remove('open');
        }

        arrows.forEach(a => a.classList.remove('open'));
    }

    function handleChange(e) {

        const isMobile = e.matches;

        unbindEvents();
        resetState(isMobile);

        if (isMobile) {
            bindEvents();
        }
    }

    // init
    handleChange(mq);
    mq.addEventListener("change", handleChange);
});